import { CLAIM_TYPES_CONFIGURATION } from '../Types';

export const getLobDescription = (lob, lobConfigurationsDict) => {
  if (lob in lobConfigurationsDict) {
    return lobConfigurationsDict[lob]?.desc?.replace(' Claim', '');
  } else {
    return CLAIM_TYPES_CONFIGURATION[lob]?.desc;
  }
};
